import React, { createContext } from 'react';
import useInput from '../Hooks/useInput';

export const InputContext = createContext({});

export default function InputProvider(props: { children: React.ReactChild }): JSX.Element {
  const currInput = useInput();
  return <InputContext.Provider value={currInput}>{props.children}</InputContext.Provider>;
}
